import { render, staticRenderFns } from "./Command.vue?vue&type=template&id=46001ffc&scoped=true&"
import script from "./Command.vue?vue&type=script&lang=ts&"
export * from "./Command.vue?vue&type=script&lang=ts&"
import style0 from "./Command.vue?vue&type=style&index=0&id=46001ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46001ffc",
  null
  
)

export default component.exports